/* ============================================================
 * Trova Veicolo — Core JS condiviso
 * ============================================================
 * Espone window.TrovaVeicolo con API unificata per 3 modalità:
 *   - full:   pagina piena con chip categoria + chip tipo + risultati
 *   - mini:   widget compatto con top N risultati + link alla piena
 *   - drawer: drawer laterale triggerato da icona
 * ============================================================ */
(function(){
  'use strict';

  var DB_CACHE = null;
  var DB_PROMISE = null;

  var CAT_ICON = {
    auto:    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12l2-6h14l2 6v7H3z"/><circle cx="7" cy="16" r="1.5"/><circle cx="17" cy="16" r="1.5"/></svg>',
    moto:    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="17" r="3"/><circle cx="18" cy="17" r="3"/><path d="M6 17l3-6h6l3 6M9 11l-1-3h4"/></svg>',
    camper:  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="8" width="16" height="9" rx="1"/><path d="M18 11l4 2v4h-4"/><circle cx="7" cy="17" r="1.5"/><circle cx="18" cy="17" r="1.5"/></svg>',
    nautica: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v10l8 2-8 8-8-8 8-2V2z"/></svg>'
  };
  // Testi tradotti dal tema (snippets/am-i18n.liquid); l'italiano resta come riserva.
  var I18N = (window.AM_I18N && window.AM_I18N.tv) || {};
  function tr(k, it, vars) {
    var s = I18N[k] || it;
    if (vars) for (var v in vars) s = s.split('[' + v + ']').join(vars[v]);
    return s;
  }
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var LANG = document.documentElement.lang || 'it-IT';

  var CAT_LABELS = { auto: tr('cat_auto', 'Auto'), moto: tr('cat_moto', 'Moto'), camper: tr('cat_camper', 'Camper'), nautica: tr('cat_nautica', 'Nautica') };

  function fmtNum(n) { return new Intl.NumberFormat(LANG).format(n); }
  function normalize(s){ return (s||'').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,''); }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function loadDB(url) {
    if (DB_CACHE) return Promise.resolve(DB_CACHE);
    if (DB_PROMISE) return DB_PROMISE;
    DB_PROMISE = fetch(url, {cache: 'force-cache'})
      .then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(function(d){ DB_CACHE = d; return d; });
    return DB_PROMISE;
  }

  // Filtro sul singolo prodotto (db v1.3: pt = tag, pb = marca). Il veicolo tiene solo i suoi
  // 4 tag piu' frequenti: filtrare li' perdeva chi ha quel tipo come quinto. Senza pt si torna al vecchio.
  function prodFilter(db, tagFilter, brandFilter) {
    var tagIdx = tagFilter ? db.t.indexOf(tagFilter) : -1;
    var brandIdx = brandFilter && db.b ? db.b.indexOf(brandFilter.toUpperCase()) : -1;
    if (tagIdx < 0 && brandIdx < 0) return null;
    if (!db.pt) return null;
    return function(p) {
      return (tagIdx < 0 || db.pt[p] === tagIdx) && (brandIdx < 0 || db.pb[p] === brandIdx);
    };
  }

  function searchVeicoli(db, query, catFilter, tagFilter, maxResults, brandFilter) {
    var terms = normalize(query).split(/\s+/).filter(function(t){ return t.length >= 2; });
    var catIdx = catFilter && catFilter !== 'all' ? db.c.indexOf(catFilter) : -1;
    if (catFilter && catFilter !== 'all' && catIdx < 0) return [];
    var tagIdx = tagFilter ? db.t.indexOf(tagFilter) : -1;
    var pf = prodFilter(db, tagFilter, brandFilter);

    var out = [];
    var v = db.v, m = db.m;
    for (var i = 0; i < v.length; i++) {
      var r = v[i];
      if (catIdx >= 0 && r[3] !== catIdx) continue;
      if (pf) { if (!r[4].some(pf)) continue; }
      else if (tagIdx >= 0 && r[5].indexOf(tagIdx) === -1) continue;
      if (terms.length) {
        var hay = normalize(m[r[0]] + ' ' + r[1] + ' ' + r[2]);
        var allMatch = true;
        for (var t = 0; t < terms.length; t++) {
          if (hay.indexOf(terms[t]) === -1) { allMatch = false; break; }
        }
        if (!allMatch) continue;
      }
      out.push(i);
      if (out.length >= maxResults) break;
    }
    return out;
  }

  function countVehiclesByCat(db) {
    var counts = {all: db.v.length};
    for (var i = 0; i < db.v.length; i++) {
      var c = db.c[db.v[i][3]];
      counts[c] = (counts[c] || 0) + 1;
    }
    return counts;
  }

  function countVehiclesByTag(db) {
    var counts = {};
    for (var i = 0; i < db.v.length; i++) {
      var tags = db.v[i][5];
      for (var j = 0; j < tags.length; j++) {
        var name = db.t[tags[j]];
        counts[name] = (counts[name] || 0) + 1;
      }
    }
    return counts;
  }

  function buildCardHTML(db, vIdx, opts) {
    opts = opts || {};
    var row     = db.v[vIdx];
    var marca   = db.m[row[0]];
    var modello = row[1];
    var anno    = row[2];
    var cat     = db.c[row[3]];
    var pf      = prodFilter(db, opts.highlightTag, opts.brand);
    var prods   = pf ? row[4].filter(pf) : row[4];
    var tagIdxs = row[5];

    var tagsHtml = tagIdxs.map(function(ti){
      var tagName = db.t[ti];
      var hl = (tagName === opts.highlightTag);
      return '<span class="tv-tag' + (hl ? ' tv-tag-hl' : '') + '">' + escapeHtml(tagName) + '</span>';
    }).join('');

    var maxProds = opts.maxProds || 30;
    var prodsShown = prods.slice(0, maxProds);
    var prodsList = prodsShown.map(function(pIdx){
      var sku = db.p[pIdx];
      var nome = (db.n && db.n[pIdx]) || '';
      var url = ROOT + 'search?q=' + encodeURIComponent(sku);
      return '<li><a class="tv-prod" href="' + url + '">' +
        '<div class="tv-prod-info">' +
          '<div class="tv-prod-nome">' + escapeHtml(nome || sku) + '</div>' +
          (nome ? '<div class="tv-prod-sku">SKU ' + escapeHtml(sku) + '</div>' : '') +
        '</div>' +
        '<svg class="tv-prod-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>' +
      '</a></li>';
    }).join('');

    if (prods.length > maxProds) {
      prodsList += '<li class="tv-prod-more">' + tr('more', '…e altri [n] prodotti (affina la ricerca)', { n: prods.length - maxProds }) + '</li>';
    }

    return '<details class="tv-card"' + (opts.openFirst ? ' open' : '') + '>' +
      '<summary class="tv-card-head">' +
        '<span class="tv-card-cat" aria-hidden="true">' + (CAT_ICON[cat] || '') + '</span>' +
        '<div class="tv-card-info">' +
          '<h3 class="tv-card-title"><span class="tv-marca">' + escapeHtml(marca) + '</span> ' +
          (modello ? '<span class="tv-modello">' + escapeHtml(modello) + '</span>' : '') + '</h3>' +
          '<div class="tv-card-meta">' + (anno ? '<span class="tv-card-anno">' + escapeHtml(anno) + '</span>' : '') + '</div>' +
        '</div>' +
        '<div class="tv-card-tags">' + tagsHtml + '</div>' +
        '<span class="tv-card-badge">' + prods.length + '<span class="tv-card-badge-lbl">' + ' ' + (prods.length === 1 ? tr('product', 'prodotto') : tr('products', 'prodotti')) + '</span></span>' +
        '<svg class="tv-card-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>' +
      '</summary>' +
      '<div class="tv-card-body"><ul class="tv-prod-list">' + prodsList + '</ul></div>' +
    '</details>';
  }

  /* ======================================================
   * MODE: FULL — pagina piena con chip + filtri + risultati
   * ====================================================== */
  function mountFull(cfg) {
    var root = cfg.root;
    var db = cfg.db;
    var MAX_RESULTS = cfg.maxResults || 60;
    var DEBOUNCE_MS = 180;

    var state = { cat: 'all', tag: null, query: '' };
    var catCounts = countVehiclesByCat(db);
    var tagCounts = countVehiclesByTag(db);
    var topTags = Object.keys(tagCounts).sort(function(a,b){ return tagCounts[b]-tagCounts[a]; }).slice(0, 12);

    var initialQuery = cfg.initialQuery || '';
    // link dalle landing dei mondi: ?q= veicolo, ?cat= auto|moto|camper, ?tipo= tag, ?marchio= marca
    var qs = new URLSearchParams(window.location.search);
    if (!initialQuery && qs.get('q')) initialQuery = qs.get('q');
    state.query = initialQuery;
    var qCat = qs.get('cat');
    if (qCat && catCounts[qCat]) state.cat = qCat;
    var qTipo = qs.get('tipo');
    if (qTipo && db.t.indexOf(qTipo) > -1) {
      state.tag = qTipo;
      if (topTags.indexOf(qTipo) < 0) topTags.unshift(qTipo);
    }
    var qMarchio = qs.get('marchio');
    state.brand = qMarchio && db.b && db.b.indexOf(qMarchio.toUpperCase()) > -1 ? qMarchio.toUpperCase() : null;

    root.innerHTML =
      '<header class="tv-hero">' +
        (cfg.showHero !== false ?
          '<span class="tv-eyebrow">' + escapeHtml(cfg.eyebrow || tr('eyebrow', 'Accessori su misura')) + '</span>' +
          '<h2 class="tv-title">' + escapeHtml(cfg.title || tr('title', 'Trova gli accessori per il tuo veicolo')) + '</h2>'
          : '') +
        '<p class="tv-subtitle">' + tr('subtitle', 'Cerca tra <strong>[v]</strong> veicoli compatibili · [p] prodotti', { v: fmtNum(db.meta.n_veicoli), p: fmtNum(db.meta.n_prodotti) }) + '</p>' +
      '</header>' +

      '<div class="tv-chips" role="tablist" aria-label="' + tr('cat_aria', 'Categoria veicolo') + '">' +
        '<button class="tv-chip is-active" data-cat="all">' +
          '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
          '<span class="tv-chip-label">' + tr('all', 'Tutti') + '</span>' +
          '<span class="tv-chip-count">' + fmtNum(catCounts.all || 0) + '</span>' +
        '</button>' +
        ['auto','moto','camper'].filter(function(c){ return catCounts[c]; }).map(function(c){
          return '<button class="tv-chip" data-cat="' + c + '">' +
            CAT_ICON[c] + '<span class="tv-chip-label">' + CAT_LABELS[c] + '</span>' +
            '<span class="tv-chip-count">' + fmtNum(catCounts[c]) + '</span>' +
          '</button>';
        }).join('') +
      '</div>' +

      '<div class="tv-tagbar">' +
        '<div class="tv-tagbar-label">' + tr('filter_label', 'Filtra per tipo accessorio') + '</div>' +
        '<div class="tv-tagchips" role="group" aria-label="' + tr('filter_aria', 'Filtra per tipo prodotto') + '"></div>' +
      '</div>' +

      '<div class="tv-search">' +
        '<svg class="tv-search-ico" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
        '<input type="text" class="tv-input" placeholder="' + escapeHtml(tr('placeholder', 'Es: Ford Fiesta, BMW X5, Fiat Panda 2018…')) + '" autocomplete="off" spellcheck="false" aria-label="' + escapeHtml(tr('search_aria', 'Cerca veicolo')) + '" value="' + escapeHtml(initialQuery) + '">' +
        '<button type="button" class="tv-clear" aria-label="Cancella" ' + (initialQuery ? '' : 'hidden') + '>' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</div>' +

      '<p class="tv-status" aria-live="polite"></p>' +
      '<div class="tv-results" role="list"></div>' +
      '<div class="tv-empty" hidden>' +
        '<svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
        '<h3>' + tr('empty_title', 'Nessun veicolo trovato') + '</h3><p>' + tr('empty_text', 'Prova a semplificare la ricerca o cambia filtri.') + '</p>' +
      '</div>';

    var catChips = root.querySelectorAll('.tv-chip[data-cat]');
    catChips.forEach(function(c){ c.classList.toggle('is-active', c.dataset.cat === state.cat); });
    var tagContainer = root.querySelector('.tv-tagchips');
    var searchInput = root.querySelector('.tv-input');
    var clearBtn = root.querySelector('.tv-clear');
    var statusEl = root.querySelector('.tv-status');
    var resultsEl = root.querySelector('.tv-results');
    var emptyEl = root.querySelector('.tv-empty');
    var debTimer = null;

    function renderTagChips() {
      var html = '<button class="tv-tagchip' + (state.tag === null ? ' is-active' : '') + '" data-tag="">' + tr('all_types', 'Tutti i tipi') + '</button>';
      topTags.forEach(function(t){
        var active = state.tag === t;
        html += '<button class="tv-tagchip' + (active ? ' is-active' : '') + '" data-tag="' + escapeHtml(t) + '">' +
          escapeHtml(t) + ' <span class="tv-tagchip-count">' + fmtNum(tagCounts[t]) + '</span></button>';
      });
      tagContainer.innerHTML = html;
      tagContainer.querySelectorAll('.tv-tagchip').forEach(function(b){
        b.addEventListener('click', function(){
          state.tag = b.dataset.tag || null;
          renderTagChips();
          render();
        });
      });
    }

    function render() {
      var t0 = performance.now();
      var idxs = searchVeicoli(db, state.query, state.cat, state.tag, MAX_RESULTS, state.brand);
      var ms = Math.round(performance.now() - t0);

      if (!idxs.length) {
        emptyEl.hidden = false;
        resultsEl.innerHTML = '';
        statusEl.innerHTML = '';
        return;
      }
      emptyEl.hidden = true;

      var parts = ['<strong>' + fmtNum(idxs.length) + '</strong> ' + (idxs.length === 1 ? tr('vehicle', 'veicolo') : tr('vehicles', 'veicoli'))];
      if (idxs.length >= MAX_RESULTS) parts.push(tr('first_n', '(primi [n])', { n: MAX_RESULTS }));
      if (state.tag) parts.push(tr('filtered_by', 'filtrati per [tag]', { tag: '<strong>' + escapeHtml(state.tag) + '</strong>' }));
      if (state.brand) parts.push(tr('brand', 'marca [b]', { b: '<strong>' + escapeHtml(state.brand) + '</strong>' }) + ' <a class="tv-togli-marca" href="#">' + tr('remove', 'togli') + '</a>');
      if (state.query) parts.push(tr('for_query', 'per "[q]"', { q: escapeHtml(state.query) }));
      statusEl.innerHTML = parts.join(' ') + ' <span class="tv-status-ms">· ' + ms + 'ms</span>';
      var togli = statusEl.querySelector('.tv-togli-marca');
      if (togli) togli.addEventListener('click', function(e){ e.preventDefault(); state.brand = null; render(); });

      var html = '';
      for (var i = 0; i < idxs.length; i++) {
        html += buildCardHTML(db, idxs[i], { highlightTag: state.tag, brand: state.brand, openFirst: i === 0 });
      }
      resultsEl.innerHTML = html;
    }

    // Events
    searchInput.addEventListener('input', function(){
      state.query = searchInput.value.trim();
      clearBtn.hidden = !state.query;
      clearTimeout(debTimer);
      debTimer = setTimeout(render, DEBOUNCE_MS);
    });
    clearBtn.addEventListener('click', function(){
      searchInput.value = '';
      state.query = '';
      clearBtn.hidden = true;
      searchInput.focus();
      render();
    });
    catChips.forEach(function(c){
      c.addEventListener('click', function(){
        catChips.forEach(function(cc){ cc.classList.remove('is-active'); });
        c.classList.add('is-active');
        state.cat = c.dataset.cat;
        render();
      });
    });

    renderTagChips();
    render();
    if (cfg.autofocus !== false) setTimeout(function(){ searchInput.focus(); }, 50);
  }

  /* ======================================================
   * MODE: MINI — widget compatto con top N risultati
   * ====================================================== */
  function mountMini(cfg) {
    var root = cfg.root;
    var db = cfg.db;
    var TOP_N = cfg.topN || 5;
    var TARGET_URL = cfg.targetUrl || (ROOT + 'pages/trova-veicolo');

    root.innerHTML =
      '<div class="tv-mini">' +
        (cfg.title ? '<h3 class="tv-mini-title">' + escapeHtml(cfg.title) + '</h3>' : '') +
        (cfg.subtitle ? '<p class="tv-mini-sub">' + escapeHtml(cfg.subtitle) + '</p>' : '') +
        '<div class="tv-search">' +
          '<svg class="tv-search-ico" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
          '<input type="text" class="tv-input" placeholder="' + escapeHtml(tr('mini_placeholder', 'Cerca marca, modello, anno…')) + '" autocomplete="off" spellcheck="false">' +
        '</div>' +
        '<div class="tv-mini-results" hidden></div>' +
        '<a href="' + TARGET_URL + '" class="tv-mini-cta">' +
          tr('browse_all', 'Sfoglia tutti i [n] veicoli compatibili', { n: fmtNum(db.meta.n_veicoli) }) +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>' +
        '</a>' +
      '</div>';

    var input = root.querySelector('.tv-input');
    var resultsEl = root.querySelector('.tv-mini-results');
    var debTimer = null;

    function render() {
      var q = input.value.trim();
      if (q.length < 2) {
        resultsEl.hidden = true; resultsEl.innerHTML = '';
        return;
      }
      var idxs = searchVeicoli(db, q, 'all', null, TOP_N);
      if (!idxs.length) {
        resultsEl.hidden = false;
        resultsEl.innerHTML = '<div class="tv-mini-empty">' + tr('mini_empty', 'Nessun veicolo trovato per "[q]"', { q: escapeHtml(q) }) + '</div>';
        return;
      }
      var html = idxs.map(function(vIdx){
        var row = db.v[vIdx];
        var marca = db.m[row[0]];
        var modello = row[1];
        var anno = row[2];
        var cat = db.c[row[3]];
        var href = TARGET_URL + '?q=' + encodeURIComponent(marca + ' ' + modello + ' ' + anno).replace(/%20$/, '');
        return '<a class="tv-mini-item" href="' + href + '">' +
          '<span class="tv-mini-item-ico">' + (CAT_ICON[cat] || '') + '</span>' +
          '<span class="tv-mini-item-txt">' +
            '<strong>' + escapeHtml(marca) + '</strong> ' + escapeHtml(modello) +
            '<span class="tv-mini-item-anno">' + escapeHtml(anno) + '</span>' +
          '</span>' +
          '<span class="tv-mini-item-count">' + row[4].length + '</span>' +
        '</a>';
      }).join('');
      resultsEl.innerHTML = html;
      resultsEl.hidden = false;
    }
    input.addEventListener('input', function(){
      clearTimeout(debTimer);
      debTimer = setTimeout(render, 200);
    });
  }

  /* ======================================================
   * MODE: DRAWER — icona + drawer laterale
   * ====================================================== */
  function openDrawer(cfg) {
    var db = cfg.db;
    var drawer = document.getElementById('tvDrawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    var panel = drawer.querySelector('.tv-drawer-panel .tv-drawer-content');
    if (panel && !panel.dataset.mounted) {
      mountFull({
        root: panel, db: db,
        maxResults: 40,
        showHero: false,
        autofocus: true
      });
      panel.dataset.mounted = '1';
    }
  }
  function closeDrawer() {
    var drawer = document.getElementById('tvDrawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function setupDrawer(cfg) {
    var drawer = document.getElementById('tvDrawer');
    if (!drawer) return;
    drawer.querySelector('.tv-drawer-backdrop').addEventListener('click', closeDrawer);
    drawer.querySelector('.tv-drawer-close').addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e){
      if ((e.key === 'Escape' || e.keyCode === 27) && drawer.classList.contains('is-open')) closeDrawer();
    });
    document.querySelectorAll('[data-tv-open]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        openDrawer(cfg);
      });
    });
  }

  /* ======================================================
   * PUBLIC API
   * ====================================================== */
  window.TrovaVeicolo = {
    init: function(options) {
      var dbUrl = options.dbUrl;
      if (!dbUrl) { console.error('[TrovaVeicolo] dbUrl required'); return; }
      loadDB(dbUrl).then(function(db){
        (options.mounts || []).forEach(function(m){
          var root = typeof m.root === 'string' ? document.getElementById(m.root) : m.root;
          if (!root) return;
          var cfg = Object.assign({}, m, { root: root, db: db });
          if (m.mode === 'full') mountFull(cfg);
          else if (m.mode === 'mini') mountMini(cfg);
        });
        if (options.drawer) {
          setupDrawer({ db: db });
        }
      }).catch(function(err){
        console.error('[TrovaVeicolo] load error:', err);
      });
    },
    openDrawer: function(){ /* richiamato dopo init */
      if (DB_CACHE) openDrawer({ db: DB_CACHE });
    },
    closeDrawer: closeDrawer
  };
})();
